<!--设施管理-->
<template>
    <div>
        <!--顶部搜索-->
        <el-row :gutter="20">
            <el-form :size="size" :model="queryInfo" label-width="100px">
                <el-col :span="4">
                    <el-form-item label="选择系统类型" prop="categoryId">
                        <el-select v-model="queryInfo.categoryId" placeholder="请选择" style="width:100%">
                            <el-option
                                    v-for="item in categoryList"
                                    :key="Number(item.value)"
                                    :label="item.label"
                                    :value="Number(item.value)">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label="输入机型" prop="model">
                        <el-input :size="size" v-model="queryInfo.model"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="2">
                    <el-button :size="size" v-permission="['BUSINESS-FACILITY-QUERY']" type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
                </el-col>
                <el-col :span="2" :offset="12" style="text-align: right">
                    <el-button :size="size" v-permission="['BUSINESS-FACILITY-CREATE']" type="primary" icon="el-icon-plus" @click="addDialog">添加</el-button>
                </el-col>
            </el-form>
        </el-row>
        <!--内容展示-->
        <el-row style="">
            <el-table v-loading="loading" ref="tableRef" border stripe checkBox :height="treeTableHeight" :data="tablelist" >
                <template v-for="(v,k) in columns">
                    <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-if="v.label==='操作'">
                        <template slot-scope="scope">
                            <el-button v-permission="['BUSINESS-FACILITY-UPDATE']" type="primary" icon="el-icon-edit" size="mini" round @click="editDialog(scope.row)">编辑</el-button>
                            <el-button v-permission="['BUSINESS-FACILITY-DELETE']" type="danger" icon="el-icon-delete" size="mini" round @click="deleteDialog(scope.row)">删除</el-button>
                            <!--<el-tooltip class="item" effect="dark" content="设施删除有疑问！！！" placement="right-start">
                            </el-tooltip>-->
                        </template>
                    </el-table-column>
                    <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-else-if="v.prop==='categoryId'">
                        <template slot-scope="scope">
                            <span>{{getCategory(scope.row.categoryId)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :type="v.type" :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-else></el-table-column>
                </template>
            </el-table>
            <Pagination v-show="total>0" :total="total" :page="queryInfo.pagenum" :limit="queryInfo.pagesize" @updatePage="handleCurrentChange" @updateLimit="handleSizeChange" ></Pagination>
        </el-row>
        <!--categoryId=1---热暖==壁挂  风量、风量单位不要
        categoryId=2---新风  只要风量、风量单位
        categoryId=3---净水  基本的三项-->
        <el-dialog :title="titleForm"
                   width="50%"
                   @close="handleClose"
                   :visible.sync="editDialogVisible"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :destroy-on-close="true">
            <el-form :model="editItem" :rules="formRules" ref="editFormRef" label-width="100px">
                <el-row >
                    <el-col :span="8">
                        <el-form-item label="机型：" prop="model">
                            <el-input v-model="editItem.model"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="品牌：" prop="brand">
                            <el-input v-model="editItem.brand"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="系统类型：" prop="categoryId">
                            <el-select clearable v-model="editItem.categoryId" placeholder="请选择" style="width:100%">
                                <el-option
                                        v-for="item in categoryList"
                                        :key="Number(item.value)"
                                        :label="item.label"
                                        :value="Number(item.value)">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-show="editItem.categoryId===1">
                    <el-col :span="8">
                        <el-form-item label="功率：" prop="power">
                            <el-input v-model="editItem.power" placeholder="0"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="最大功率：" prop="maxPower">
                            <el-input v-model="editItem.maxPower" placeholder="0.0"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="功率单位：" prop="powerUnit">
                            <el-input v-model="editItem.powerUnit" placeholder="kwh"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-show="editItem.categoryId==='1'||editItem.categoryId===1">
                    <el-col :span="8">
                        <el-form-item label="热值：" prop="heat">
                            <el-input v-model="editItem.heat" placeholder="0"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="效率：" prop="efficiency">
                            <el-input v-model="editItem.efficiency" placeholder="0.0"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="燃气参数：" prop="airParam">
                            <el-input v-model="editItem.airParam" placeholder="0.0000"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-show="editItem.categoryId==='2'||editItem.categoryId===2">
                    <el-col :span="8">
                        <el-form-item label="风量：" prop="airVolume">
                            <el-input v-model="editItem.airVolume"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="风量单位：" prop="airUnit">
                            <el-input v-model="editItem.airUnit" placeholder="m³/h"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="editFun">提 交</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {facilityPage, facilityAdd, facilityEdit, facilityRemove} from '@/api/facility'
import Pagination from '@/components/pagination/index'
import {dictDataList} from '@/api/dict'
export default {
    name: 'BUSINESS-FACILITY',
    components: {
        Pagination
    },
    data() {
        return {
            tablelist: [],
            columns: [
                {
                    label: '机型',
                    prop: 'model',
                    fixed: 'left',
                    width: '120px'
                },{
                    label: '品牌',
                    prop: 'brand'
                },{
                    label: '系统类型',
                    prop: 'categoryId',
                    width: '120px'
                },{
                    label: '功率',
                    prop: 'power',
                    //width: '100px'
                },{
                    label: '最大功率',
                    prop: 'maxPower',
                    //width: '100px'
                },{
                    label: '功率单位',
                    prop: 'powerUnit',
                    //width: '100px'
                },{
                    label: '燃气参数',
                    prop: 'airParam'
                },{
                    label: '风量',
                    prop: 'airVolume'
                },{
                    label: '风量单位',
                    prop: 'airUnit'
                },{
                    label: '热值',
                    prop: 'heat'
                },{
                    label: '效率',
                    prop: 'efficiency'
                },{
                    label: '操作',
                    type: 'template',
                    template: 'action',
                    width: '180px',
                    fixed: 'right'
                }
            ],
            treeTableHeight: 650,
            total: 0,
            queryInfo: {
                pagesize: 10,
                pagenum: 1,
                // 产品分类  下拉
                categoryId: null,
                // 机型输入框
                model: null
            },
            editItem:{

            },
            editDialogVisible: false,
            formRules: {
                model: [
                    { required: true, message: '请输入机型', trigger: 'blur' }
                ],
                brand: [
                    { required: true, message: '请输入品牌', trigger: 'blur' }
                ],
                categoryId: [
                    { required: true, message: '请选择产品类型', trigger: 'blur' }
                ]
            },
            categoryList: [],
            titleForm: '',
            size:this.COMMON.size,
            loading: true
        }
    },
    methods: {
        getHeight() {
            // this.objstyle.height = window.innerHeight - 170 -55 -40 + 'px'
            this.treeTableHeight = window.innerHeight - 60 -40 -55 -62 -32 + 'px'
        },
        init(){
            if(this.queryInfo.model!=undefined){
                this.queryInfo.model = this.queryInfo.model.trim()
            }
            let  param= {}
            param.current = this.queryInfo.pagenum
            param.size = this.queryInfo.pagesize
            this.loading = true
            facilityPage(param,this.queryInfo).then(response => {
                if (response.code != 200)
                    return this.$message.error('获取设施失败！')
                this.tablelist = response.data.records
                this.total = response.data.total
                this.loading = false
            })
        },
        addDialog(){
            this.titleForm = "添加"
            this.editItem = {
                categoryId:1
            }
            this.editDialogVisible = true
        },
        editDialog(item){
            this.titleForm = "编辑"
            this.editItem = JSON.parse(JSON.stringify(item))
            // console.log(this.editItem,item)
            this.editDialogVisible = true
        },
        async deleteDialog(item){
            console.log('要删除的设施',item.id)
            const confirmResult = await this.$confirm('此操作将删除该数据记录, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).catch(err => err)
            // 如果用户确认删除，则返回值未字符串 confirm
            // 如果用户取消了删除，则返回值未字符串 cancel
            if (confirmResult !== 'confirm') {
                return this.$message.info('取消删除')
            }
            facilityRemove(item.id).then(response => {
                if(response.code!=200){
                    return this.$message.error(response.msg)
                }
                this.$message.success(response.msg)
                this.init()
            })
        },
        handleSizeChange(newSize) {
            this.queryInfo.pagesize = newSize
            this.init()
        },
        /**
         * 分页组件切换页事件处理
         * @param newPage
         */
        handleCurrentChange(newPage) {
            this.queryInfo.pagenum = newPage
            this.init()
        },
        handleClose() {
            this.$refs.editFormRef.resetFields()
            this.editDialogVisible = false
        },
        editFun(){
            this.$refs.editFormRef.validate(async valid => {
                if (!valid) return
                if(this.titleForm==='添加'){
                    facilityAdd(this.editItem).then(response => {
                        if(response.code!=200){
                            return this.$message.error(response.msg)
                        }
                        this.$message.success(response.msg)
                        this.editDialogVisible = false
                        this.init()
                    })
                }else if(this.titleForm==='编辑'){
                    facilityEdit(this.editItem).then(response => {
                        if(response.code!=200){
                            return this.$message.error(response.msg)
                        }
                        this.$message.success(response.msg)
                        this.editDialogVisible = false
                        this.init()
                    })
                }
            })
        },
        getCategoryList(){
            /*let param = {}
            param.current = 1
            param.size = 100*/
            let data={type: 'business_facility_category'}
            dictDataList(data).then(response => {
                if (response.code != 200)
                    return this.$message.error('获取产品类型数据失败！')
                this.categoryList = response.data //.records
                // console.log('产品类型数据', this.categoryList)
            })
        },
        getCategory(categoryId){
            let arr = this.categoryList.filter(item=>{
                return item.value === categoryId.toString()
            })
            // console.log(arr)
            if(arr.length>0){
                return arr[0].label
            }else{
                return ''
            }
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryInfo.pagenum=1
            this.init()
        }
    },
    created(){
        this.getHeight()
        window.addEventListener('resize', this.getHeight)
        this.init()
        this.getCategoryList()
    },
    activated(){
        this.$refs.tableRef.doLayout()
    }
}
</script>

<style scoped>

</style>
